/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

/**
 * `DashboardOverview` type.
 */

type DashboardOverview = {
  total: number;
  plot: any;
  totalNegative: string;
  omittedBalances: Record<number, number>;
};

/**
 * Get dashboard overview.
 */

function getDashboardOverview(client: AxiosInstance): Promise<DashboardOverview> {
  return client.get(resolveAppUrl('dashboardOverview')).then(({ data }) => data?.data);
}

/**
 * Export `useDashboardOverviewInvalidator`.
 */

export function useBankAccountsInvalidator() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries(['dashboardOverview']);
  }, [queryClient]);
}

/**
 * Export `useDashboardOverview`.
 */

export function useDashboardOverview() {
  const client = useRequestProvider();

  return useQuery(['dashboardOverview'], {
    queryFn: async () => {
      return await getDashboardOverview(client);
    }
  });
}
